var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "article-sort cell" },
    [
      !_vm.hideCategories
        ? _c("ArticleSort", {
            attrs: {
              categories: _vm.cats,
              preselectedCats: _vm.preselectedCats
            },
            on: { activeCategoryChanged: _vm.onCategoryChanged }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("clip-loader", {
        attrs: { loading: _vm.loading, color: "#009d9b", size: "32px" }
      }),
      _vm._v(" "),
      _c(
        "transition-group",
        {
          staticClass: "grid-x grid-margin-x article-pick-wrapper",
          attrs: { name: "list", tag: "div" }
        },
        _vm._l(_vm.posts, function(post) {
          return _c(
            "div",
            {
              key: post.id,
              staticClass: "list-item cell small-6 medium-4 large-4"
            },
            [
              _c(
                "a",
                {
                  staticClass: "article-thumbnail",
                  style: _vm.getThumb(post),
                  attrs: {
                    href: post.url,
                    title: post.title,
                    "xv-if": "post.thumbnail"
                  }
                },
                [
                  post.category
                    ? _c("span", { staticClass: "article-category-name" }, [
                        _vm._v(_vm._s(post.category.name))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  post.excerpt
                    ? _c("span", { staticClass: "article-pretext" }, [
                        _vm._v(_vm._s(post.excerpt))
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c("span", {
                staticClass: "article-publish-date",
                domProps: { innerHTML: _vm._s(post.date) }
              }),
              _vm._v(" "),
              _c("h3", [
                _c("a", {
                  staticClass: "article-link",
                  attrs: { href: post.url, title: post.title },
                  domProps: { innerHTML: _vm._s(post.title) }
                })
              ])
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.showLoadMore && !_vm.disableLoadMore
        ? _c("div", { staticClass: "button-container text-center" }, [
            _c("a", {
              staticClass: "button button--bordered",
              domProps: { innerHTML: _vm._s(_vm.lang.loadMore) },
              on: { click: _vm.loadMore }
            })
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59e03618", { render: render, staticRenderFns: staticRenderFns })
  }
}